import closeIcon from "include/images/dark-close-icon.svg";
import { Offcanvas } from "react-bootstrap";

const ViewAllAttemptsFlyer = ({ showModal, toggleModal, attempts }) => {
  return (
    <Offcanvas
      className={"offcanvas offcanvas-end custom-offcanvas-pannel custom-offcanvas-pannel2 "}
      show={showModal}
      onHide={toggleModal}
      id="rewardPannel"
      placement="right"
      name="rewardPannel"
      backdrop={true}
      backdropClassName={"modal-backdrop z-index-1000"}
    >
      <Offcanvas.Header>
        <div>
          <h5>Attempts</h5>
        </div>
        <div className="btn_close pointer" data-bs-dismiss="offcanvas" aria-label="Close" onClick={toggleModal}>
          <img src={closeIcon} alt="" />
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="fwc-body">
          <div className="table-responsive">
            <div className="table-responsive">
              <table className="table custom-table-striped">
                <thead>
                  <tr>
                    <th>Stage</th>
                    <th>Started</th>
                    <th>Completed</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(attempts)?.length > 0 &&
                    Object.keys(attempts)?.map((stage) => (
                      <>
                        {Object.keys(attempts[stage])?.length > 0 &&
                          Object.keys(attempts[stage])?.map((level, index) => (
                            <tr key={index}>
                              <td>
                                Stage {stage} Level {level}
                              </td>
                              <td>{attempts[stage][level]?.start}</td>
                              <td>{attempts[stage][level]?.completed}</td>
                            </tr>
                          ))}
                      </>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ViewAllAttemptsFlyer;
